import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import Invitations from './pages/Invitations'
import AddOrganization from './pages/AddOrganization'
import Organizations from './pages/Organizations'
import OrganizationDetails from './pages/OrganizationDetails'
import AddOrganizationProject from './pages/AddOrganizationProject'
import Projects from './pages/Projects'
import ProjectDetails from './pages/ProjectDetails'
import AddProject from './pages/AddProject'
import Tasks from './pages/Tasks'
import TaskDetails from './pages/TaskDetails'
import AddUser from './pages/AddUser'
import { useAuth } from './hooks/useAuth'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!user.is_superuser) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="organizations" element={<Organizations />} />
        <Route path="organizations/add" element={<AddOrganization />} />
        <Route path="organizations/:id" element={<OrganizationDetails />} />
        <Route path="organizations/:id/projects/add" element={<AddOrganizationProject />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/add" element={<AddProject />} />
        <Route path="projects/:id" element={<ProjectDetails />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="tasks/:id" element={<TaskDetails />} />
        <Route path="users" element={<Users />} />
        <Route path="users/add" element={<AddUser />} />
        <Route path="invitations" element={<Invitations />} />
      </Route>
    </Routes>
  )
}

export default App

